
export const BASE_URL = document.querySelector('[name="backend-url"]').content;
